import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { updateTrips } from "../../../../Redux/Slices/trips.slice";
import { LOCATION_TYPE } from "../../../Location/Data";
import SelectedRadioIcon, {
  UnselectedRadioIcon,
} from "../../../../Common/Svgs/SelectedRadioIcon";

const LocationTypeSelector = ({ data, totalLength }) => {
  const dispatch = useDispatch();

  const { stops } = useSelector((state) => state.trips);

  // to update the type of location for a stop
  const handleLocationType = (value) => {
    const localStops = stops.map((s) => {
      if (s.id === data.id && s.locationType !== value) {
        return {
          ...s,
          locationType: value,
          location: "Stop",
          locationId: "1",
          activities: [],
        };
      }

      return s;
    });

    dispatch(updateTrips({ key: "stops", value: localStops }));
  };

  // do not show the location radio button for first and last stop
  if (data.id === 1 || data.id === totalLength) {
    return null;
  }

  return (
    <div className="mt-3">
      <p className="mb-1.5 font-aileron font-normal text-xs text-dark-gray capitalize">
        Type Of Location
      </p>

      <div className="flex items-center gap-x-2">
        <div
          role="button"
          className={`flex items-center gap-x-1 cursor-pointer rounded-md px-2 py-1 w-[135px] h-[26px] transform transition-colors duration-100
          ${
            data?.locationType === LOCATION_TYPE.COLLECTION
              ? "bg-primary text-white"
              : "bg-primary-10 text-primary"
          }
          `}
          onClick={() => handleLocationType(LOCATION_TYPE.COLLECTION)}
        >
          {data?.locationType === LOCATION_TYPE.COLLECTION ? (
            <SelectedRadioIcon />
          ) : (
            <UnselectedRadioIcon />
          )}

          <p className="font-poppins text-xs font-medium capitalize">
            Collection Point
          </p>
        </div>

        <div
          role="button"
          className={`flex items-center gap-x-1 cursor-pointer rounded-md px-2 py-1 w-[122px] h-[26px] transform transition-colors duration-100
          ${
            data?.locationType === LOCATION_TYPE.DELIVERY
              ? "bg-primary text-white"
              : "bg-primary-10 text-primary"
          }
          `}
          onClick={() => handleLocationType(LOCATION_TYPE.DELIVERY)}
        >
          {data.locationType === LOCATION_TYPE.DELIVERY ? (
            <SelectedRadioIcon />
          ) : (
            <UnselectedRadioIcon />
          )}
          <p className="font-poppins text-xs font-medium capitalize">
            Delivery Point
          </p>
        </div>
      </div>
    </div>
  );
};

export default LocationTypeSelector;
